'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var jsxRuntime = require('react/jsx-runtime');
var styled = require('@emotion/styled');
var coreRenderer = require('@tempi/core-renderer');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

const WebsiteFooter = ({ children }) => {
  var _a, _b;
  const { globalData } = coreRenderer.useStore();
  const re = new RegExp((_a = globalData == null ? void 0 : globalData.powerByConfig) == null ? void 0 : _a.regexTempiFreeDomain);
  const isFreeDomain = typeof window !== "undefined" && re.test(window.location.href);
  return /* @__PURE__ */ jsxRuntime.jsxs(jsxRuntime.Fragment, {
    children: [
      children,
      isFreeDomain ? /* @__PURE__ */ jsxRuntime.jsxs(PowerBy, {
        children: [
          "Powered by",
          /* @__PURE__ */ jsxRuntime.jsxs(StyledLink, {
            href: (_b = globalData == null ? void 0 : globalData.powerByConfig) == null ? void 0 : _b.powerByDomain,
            target: "_blank",
            children: [
              " ",
              "Tempi"
            ]
          })
        ]
      }) : null
    ]
  });
};
const PowerBy = styled__default["default"].p`
  width: 100%;
  text-align: center;
  font-weight: 400;
  padding-bottom: 10px;
`;
const StyledLink = styled__default["default"].a`
  color: #7367f0;

  &:hover {
    color: #7367f0;
    opacity: 0.8;
    cursor: pointer;
  }
`;
WebsiteFooter.displayName = "WebsiteFooter";

exports.WebsiteFooter = WebsiteFooter;
